import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import "../css/aboutUs.css";
import Banner from "../components/Banner";
import CTASection from "../components/CTASection";
import bannerImage from "../img/banner/ZTO-Banner.png";
import visionImage from "../img/about-us-section-3.png";
import { useEffect } from "react";
import brandStoryMobile from "../img/about.png";
import bgAboutSection3 from "../img/bg-about-section3.jpg";

const AboutUs = () => {
  useEffect(() => {
    const handleScroll = () => {
      const parallaxElements = document.querySelectorAll(".parallax-image");
      parallaxElements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const speed = 0.5;
        const yPos = -(rect.top * speed);
        element.style.transform = `translateY(${yPos}px)`;
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="container-fluid p-0 web-cover about-us">
      <Header />
      <Banner
        title="Về chúng tôi"
        backgroundImage={bannerImage}
        breadcrumb={
          <>
            <Link to={"/"} className="text-white p-2">
              Trang chủ
            </Link>
            <span>{">"}</span>
            <Link to={"/about-us"} className="text-white p-2">
              Về chúng tôi
            </Link>
          </>
        }
      />

      <div className="container row my-5">
        <div className="col-md-5 d-flex flex-column justify-content-center align-items-center p-1 p-md-4">
          <div className="about-title">
            <h3>ZTO VIỆT NAM</h3>
          </div>
          <div className="about-sub-title text-center w-100 text-secondary">
            Hệ sinh thái Logistics toàn diện hàng đầu Việt Nam
          </div>
          <div className="about-description pt-md-3">
            <p>
              ZTO Việt Nam là đơn vị vận chuyển Trung - Việt, ứng dụng công nghệ
              số và AI để tối ưu tốc độ, chi phí và trải nghiệm người dùng.
            </p>
            <p>
              Chúng tôi cung cấp dịch vụ logistics toàn diện với kho tại Hà Nội,
              giao hàng nội địa trong 24h và tuyến Trung-Việt chỉ 2 ngày, giúp
              cá nhân, shop và doanh nghiệp TMĐT vận hành hiệu quả.
            </p>
          </div>
          <Link to="/" className="about-learn-more-btn mt-3">
            Tìm hiểu thêm
          </Link>
        </div>
        <div className="col-md-7 d-flex justify-content-center align-items-center about-video p-0 pt-3 p-md-0">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/Rsj03UwTUz4"
            title="ZTO Vietnam Introduction Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>

      <div className="brand-story text-white pt-4 py-md-5" style={{
        position: 'relative',
        zIndex: '10'
      }}>
        <div className="brand-story-header text-center">
          <h3>CÂU CHUYỆN THƯƠNG HIỆU</h3>
        </div>
        <div className="brand-story-content container my-4 my-md-5 text-center">
          <p>
            Trong thời đại mà chuỗi cung ứng đóng vai trò quyết định đến tốc độ
            phát triển của doanh nghiệp, logistics không còn đơn thuần là dịch
            vụ vận chuyển. Đó là yếu tố chiến lược để tạo nên sự khác biệt, nâng
            cao năng lực cạnh tranh.
          </p>
          <p>
            Thực tế, khi Trung Quốc vẫn giữ vai trò là “công xưởng của thế giới”
            thì doanh nghiệp Việt Nam, đặc biệt là các SME và HKD cá thể, có nhu
            cầu lớn về nhập khẩu từ Trung Quốc để phục vụ sản xuất và kinh
            doanh. Tuy nhiên, họ đang phải đối mặt với nhiều rào cản về nguồn
            cung, pháp lý hay tính minh bạch. Và đó chính là lý do ZTO Việt Nam
            ra đời – để thay đổi cục diện thị trường, giải quyết bài toán
            logistics một cách toàn diện, minh bạch và hiệu quả cho doanh nghiệp
            Việt Nam.
          </p>
          <p>
            Với nhiều năm kinh nghiệm triển khai dịch vụ Logistics Trung - Việt
            cùng đội ngũ nhân sự chuyên môn cao, chúng tôi tự tin sở hữu đầy đủ
            tiềm lực để tạo nên một Hệ sinh thái vận tải Trung - Việt toàn diện,
            minh bạch – đúng chuẩn pháp lý – vận hành bằng công nghệ thông minh.
          </p>
          <p>
            ZTO Việt Nam không đơn thuần là một đơn vị giao nhận; còn là người
            bạn đồng hành, là hệ sinh thái hậu cần đáng tin cậy cho các doanh
            nghiệp hiện đại. Chúng tôi luôn sẵn sàng lắng nghe, đồng hành, cùng
            giải quyết vấn đề, và cùng bạn chinh phục những mục tiêu lớn hơn.
          </p>
          <p>
            “Một doanh nghiệp mạnh không đi nhanh một mình – mà đi xa cùng những
            đối tác đáng tin cậy.”
          </p>
          <p>ZTO Việt Nam</p>
          <p>More than a partner</p>
        </div>
      </div>
      <div className="brand-story-mobile d-flex d-md-none m-0 p-0" style={{
        clear: 'both',
        position: 'relative',
        top: '-100px',
        maxHeight: '160px',
        zIndex: '5'
      }}>
        <img src={brandStoryMobile} alt="brand-story-mobile-img" style={{
          width:'100%',
          height: '100%',
          objectFit: 'cover',
          position: 'relative',
          zIndex: '5'
        }}/>
      </div>
      <section className="sec-ab-quote text-white">
        <div className="ab-quote">
          <div className="bg">
            <img
              width="100%"
              height="800"
              src={bgAboutSection3}
              className="attachment-full size-full"
              alt="Ảnh Vận chuyển đường biển (Sea Freight) - Vietnam Post Logistics"
              decoding="async"
              loading="lazy"
            />
          </div>
          <div className="container px-md-5 ab-quote-inner">
            <div className="ab-quote-ctn">
              <div
                className="ab-quote-text aos-init aos-animate"
                data-aos="fade-up-cus"
              >
                <p className="des">
                  Cung cấp các giải pháp logistics đáng tin cậy, nhanh chóng và
                  đổi mới, đáp ứng nhu cầu đa dạng của khách hàng. Hướng đến mục
                  tiêu kết nối cộng đồng và doanh nghiệp trên khắp Việt Nam và
                  toàn cầu.
                </p>
              </div>
              <div
                className="ab-quote-bot aos-init aos-animate"
                data-aos="fade-up-cus"
              >
                <p className="des">
                  <span
                    className="second"
                    style={{ color: "#FBAE17", fontWeight: "700" }}
                  >
                    Triết lý kinh doanh{" "}
                  </span>
                  <span
                    style={{
                      color: "#FBAE17",
                      fontWeight: "300",
                      flexShrink: "0",
                      fontSize: "0.9rem",
                    }}
                  >
                    của ZTO Việt Nam
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vision-mission">
        <div className="container-fluid">
          <div className="row align-items-center">
            {/* Ảnh bên trái */}
            <div className="col-md-5 vision-image-container d-none d-md-block">
              <div className="vision-image-wrapper">
                <img
                  src={visionImage}
                  alt="ZTO Vision Mission"
                  className="vision-image parallax-image"
                />
              </div>
            </div>

            <div className="col-md-1"></div>
            {/* Nội dung bên phải */}
            <div className="col-md-6">
              <div className="vision-content w-md-75 h-75 py-5">
                {/* Tầm nhìn */}
                <div className="vision-item pb-3">
                  <div className="vision-card">
                    <h4 className="card-title">Tầm nhìn</h4>
                    <p className="card-text">
                      ZTO Việt Nam hướng đến mục tiêu trở thành thương hiệu
                      logistics hàng đầu tại Việt Nam và khu vực châu Á, đóng
                      vai trò then chốt trong việc kết nối thương mại toàn cầu,
                      giúp doanh nghiệp Việt vươn ra thế giới bằng một hệ sinh
                      thái logistics thông minh và an toàn.
                    </p>
                  </div>
                </div>

                {/* Sứ mệnh */}
                <div className="vision-item pb-3">
                  <div className="vision-card">
                    <h4 className="card-title">Sứ mệnh</h4>
                    <p className="card-text">
                      Sứ mệnh của chúng tôi là:
                      <p>
                        "Cung cấp giải pháp logistics toàn diện – nhanh chóng,
                        minh bạch, đúng pháp lý – giúp KH, doanh nghiệp an tâm
                        kết nối và mở rộng thị trường trong môi trường thương
                        mại toàn cầu hóa.”
                      </p>
                    </p>
                  </div>
                </div>

                {/* Giá trị cốt lõi */}
                <div className="vision-item pb-3">
                  <div className="vision-card">
                    <h4 className="card-title">Giá trị cốt lõi</h4>
                    <p className="card-text">
                      Chúng tôi cam kết cung cấp dịch vụ logistics chất lượng,
                      đáng tin cậy dựa trên các giá trị cốt lõi:{" "}
                      <strong>
                        thử thách, cam kết, chính trực, trách nhiệm và tôn trọng
                      </strong>
                      . Với nền tảng vững chắc, chúng tôi hướng đến mục tiêu trở
                      thành nha cung cấp logistics hàng đầu Việt Nam.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CTASection />
      <Footer />
    </div>
  );
};

export default AboutUs;
